import React from 'react';
import HeroSection from '../HeroSection';
import ServicesSection from '../ServicesSection';
import AboutSection from '../AboutSection';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <ServicesSection />
      <AboutSection />
    </>
  );
};

export default HomePage;